import { render, staticRenderFns } from "./LetterFooterComponent.vue?vue&type=template&id=4476a203&"
import script from "./LetterFooterComponent.vue?vue&type=script&lang=ts&"
export * from "./LetterFooterComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4476a203')) {
      api.createRecord('4476a203', component.options)
    } else {
      api.reload('4476a203', component.options)
    }
    module.hot.accept("./LetterFooterComponent.vue?vue&type=template&id=4476a203&", function () {
      api.rerender('4476a203', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Letter/LetterFooterComponent.vue"
export default component.exports